import { Box } from '@mui/material';
// eslint-disable-next-line no-restricted-imports -- standalone client-side history view, no server-side pagination
import { DataGridPro } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function InternationalMeterReadingsGrid({ list }) {
  const { t } = useTranslation();

  const rows = useMemo(
    () =>
      list.toArray().map((row, idx) => ({
        id: row.get('id', idx),
        timestamp: row.get('timestamp'),
        voltage: row.get('voltage'),
        current: row.get('current'),
        power_factor: row.get('power_factor'),
        apparent_power: row.get('apparent_power'),
        real_power: row.get('real_power'),
        reactive_power: row.get('reactive_power'),
        energy: row.get('energy'),
        watt_hours: row.get('watt_hours'),
      })),
    [list],
  );

  const columns = useMemo(
    () => [
      {
        field: 'timestamp',
        headerName: t('general.timestamp'),
        width: 200,
        valueFormatter: value => (value ? format(value, 'Pp') : ''),
      },
      {
        field: 'voltage',
        headerName: t('powerData.voltageV', { defaultValue: 'Voltage (V)' }),
        width: 110,
        sortable: false,
      },
      {
        field: 'current',
        headerName: t('powerData.currentA', { defaultValue: 'Current (A)' }),
        width: 110,
        sortable: false,
      },
      {
        field: 'power_factor',
        headerName: t('powerData.powerFactor', { defaultValue: 'Power Factor' }),
        width: 130,
        sortable: false,
      },
      {
        field: 'apparent_power',
        headerName: t('powerData.apparentPowerVa', { defaultValue: 'Apparent Power (VA)' }),
        width: 170,
        sortable: false,
      },
      {
        field: 'real_power',
        headerName: t('powerData.realPowerW', { defaultValue: 'Real Power (W)' }),
        width: 140,
        sortable: false,
      },
      {
        field: 'reactive_power',
        headerName: t('powerData.reactivePowerVar', { defaultValue: 'Reactive Power (var)' }),
        width: 180,
        sortable: false,
      },
      {
        field: 'energy',
        headerName: t('powerData.energyW', { defaultValue: 'Energy (W)' }),
        width: 110,
        sortable: false,
      },
      {
        field: 'watt_hours',
        headerName: t('powerData.wattHoursWh', { defaultValue: 'Watt Hours (Wh)' }),
        width: 150,
        sortable: false,
      },
    ],
    [t],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        density="compact"
        disableRowSelectionOnClick
        hideFooter
        initialState={{ sorting: { sortModel: [{ field: 'timestamp', sort: 'desc' }] } }}
        localeText={{ noRowsLabel: t('general.noResultsMessage', { defaultValue: 'No data' }) }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Box>
  );
}

export default InternationalMeterReadingsGrid;
